// src/components/menus/TodaysPageSubMenu.tsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BeingsPageSubMenuButton } from '../common/Buttons';
import { SubMenuContainer, SubMenuCap } from './shared/MenuElements';
import { useAuth } from '../../contexts/AuthContext';
import { Permissions } from '../../utils/permissions';

interface TodaysPageSubMenuProps {
  selectedDate: string;
}

const tabItems = [
  { id: 'check-ins', label: 'CHECK-INS', minWidth: '197px' },
  { id: 'check-outs', label: 'CHECK-OUTS', minWidth: '224px' },
  { id: 'active-bookings', label: 'ACTIVE BOOKINGS', minWidth: '302px' },
  { id: 'kennels', label: 'KENNELS', minWidth: '172px' },
  { id: 'overdue', label: 'OVERDUE', minWidth: '172px' },
];

const TodaysPageSubMenu: React.FC<TodaysPageSubMenuProps> = ({
  selectedDate,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // Today's Page is otherwise open to Staff (check-ins/outs, active
  // bookings, kennels are all operational, not financial), but Overdue
  // is invoicing visibility - Staff can't reach that anywhere else in
  // the app either, so the tab itself shouldn't be offered.
  const visibleTabItems = tabItems.filter(
    (item) =>
      item.id !== 'overdue' || Permissions.canViewOverdueInvoices(user?.role)
  );

  const isActiveTab = (tabId: string): boolean => {
    const path = location.pathname;

    if (tabId === 'check-ins') {
      return (
        path.includes('/check-ins') || path === '/today' || path === '/today/'
      );
    }

    return path.includes(`/${tabId}`);
  };

  const handleTabClick = (tabId: string) => {
    navigate(`/today/${tabId}?date=${selectedDate}`);
  };

  return (
    <SubMenuContainer>
      {visibleTabItems.map((item) => (
        <BeingsPageSubMenuButton
          key={item.id}
          onClick={() => handleTabClick(item.id)}
          isActive={isActiveTab(item.id)}
          minWidth={item.minWidth}
        >
          {item.label}
        </BeingsPageSubMenuButton>
      ))}
      <SubMenuCap />
    </SubMenuContainer>
  );
};

export default TodaysPageSubMenu;
